/* MyAlma CRO (2026-10): aviso de vuelta a stock desde las tarjetas de producto (snippets/ma-bis-button.liquid).
   Usa la API de cliente de Klaviyo (la misma suscripción que el formulario de la ficha), así se dispara el flujo de vuelta a stock.
   La casilla de newsletter va desmarcada y solo suscribe si la clienta la marca. */
(function () {
  if (window.maBisInit) return;
  window.maBisInit = true;
  var COMPANY = 'Wv5ebm';
  var LIST = 'TPJx25';
  var REVISION = '2024-10-15';
  var dialog, form, titleEl, selectWrap, select, msg, submitBtn, lastTrigger;

  function build() {
    dialog = document.createElement('div');
    dialog.className = 'ma-bis';
    dialog.hidden = true;
    dialog.innerHTML =
      '<div class="ma-bis__overlay" data-ma-bis-close></div>' +
      '<div class="ma-bis__panel" role="dialog" aria-modal="true" aria-labelledby="ma-bis-title">' +
      '<button type="button" class="ma-bis__close" data-ma-bis-close aria-label="Cerrar">&times;</button>' +
      '<p class="ma-bis__eyebrow">Agotado temporalmente</p>' +
      '<h2 class="ma-bis__title" id="ma-bis-title">Te avisamos cuando vuelva</h2>' +
      '<p class="ma-bis__product"></p>' +
      '<form class="ma-bis__form" novalidate>' +
      '<div class="ma-bis__field ma-bis__variant" hidden><label for="ma-bis-variant">Opción</label><select id="ma-bis-variant"></select></div>' +
      '<div class="ma-bis__field"><label for="ma-bis-email">Tu email</label><input id="ma-bis-email" type="email" autocomplete="email" required placeholder="nombre@email.com"></div>' +
      '<label class="ma-bis__check"><input type="checkbox" id="ma-bis-nl"> Quiero recibir también la newsletter de MyAlma (consejos y ofertas)</label>' +
      '<button type="submit" class="ma-bis__submit">Avisarme</button>' +
      '<p class="ma-bis__msg" role="status" aria-live="polite"></p>' +
      '<p class="ma-bis__legal">Solo usaremos tu email para avisarte de que vuelve este producto' +
      ' (y para la newsletter si la marcas). <a href="/policies/privacy-policy" target="_blank" rel="noopener">Política de privacidad</a>.</p>' +
      '</form></div>';
    document.body.appendChild(dialog);
    form = dialog.querySelector('form');
    titleEl = dialog.querySelector('.ma-bis__product');
    selectWrap = dialog.querySelector('.ma-bis__variant');
    select = dialog.querySelector('select');
    msg = dialog.querySelector('.ma-bis__msg');
    submitBtn = dialog.querySelector('.ma-bis__submit');
    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-ma-bis-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !dialog.hidden) close();
    });
    form.addEventListener('submit', onSubmit);
  }

  function open(btn) {
    if (!dialog) build();
    lastTrigger = btn;
    var variants = [];
    try { variants = JSON.parse(btn.getAttribute('data-variants') || '[]'); } catch (e) {}
    titleEl.textContent = btn.getAttribute('data-title') || '';
    select.innerHTML = '';
    variants.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v.id;
      o.textContent = v.title;
      select.appendChild(o);
    });
    selectWrap.hidden = variants.length < 2;
    msg.textContent = '';
    msg.className = 'ma-bis__msg';
    form.hidden = false;
    submitBtn.disabled = false;
    submitBtn.hidden = false;
    form.querySelectorAll('.ma-bis__field:not(.ma-bis__variant)').forEach(function (f) { f.hidden = false; });
    dialog.hidden = false;
    document.documentElement.classList.add('ma-bis-open');
    setTimeout(function () { dialog.querySelector('#ma-bis-email').focus(); }, 30);
    try { window.clarity && window.clarity('event', 'card_back_in_stock_open'); } catch (e) {}
  }

  function close() {
    dialog.hidden = true;
    document.documentElement.classList.remove('ma-bis-open');
    if (lastTrigger) lastTrigger.focus();
  }

  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
    });
  }

  function onSubmit(e) {
    e.preventDefault();
    var email = dialog.querySelector('#ma-bis-email').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      msg.textContent = 'Revisa el email, parece que no está bien escrito.';
      msg.className = 'ma-bis__msg is-error';
      return;
    }
    var variantId = select.value;
    if (!variantId) return;
    submitBtn.disabled = true;
    msg.textContent = 'Enviando…';
    msg.className = 'ma-bis__msg';
    var jobs = [post('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }
    })];
    if (dialog.querySelector('#ma-bis-nl').checked) {
      jobs.push(post('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Aviso vuelta a stock (tarjeta)',
            profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
          },
          relationships: { list: { data: { type: 'list', id: LIST } } }
        }
      }));
    }
    Promise.all(jobs).then(function () {
      msg.textContent = '¡Hecho! Te escribiremos en cuanto vuelva a estar disponible.';
      msg.className = 'ma-bis__msg is-ok';
      form.querySelector('.ma-bis__field:not(.ma-bis__variant)').hidden = true;
      submitBtn.hidden = true;
      try { window.clarity && window.clarity('event', 'card_back_in_stock_ok'); } catch (err) {}
    }).catch(function () {
      submitBtn.disabled = false;
      msg.textContent = 'No hemos podido guardarlo. Inténtalo de nuevo o escríbenos a info@myalma.com.';
      msg.className = 'ma-bis__msg is-error';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ma-bis]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  }, true);
})();
